export default __webpack_public_path__ + "static/media/red-cardinal.3e27d84b.webp";